module.exports = __webpack_public_path__ + "static/media/thumb.a4585e50.jpg";